import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  Renderer2,
  SimpleChanges,
  inject,
  viewChild,
} from '@angular/core';
import { MatListOption } from '@angular/material/list';
import { MatMenuTrigger } from '@angular/material/menu';
import { ActivatedRoute } from '@angular/router';
import { fromEvent } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';

import { QueryStringTypes } from 'src/app/configs/query-string-types';
import { RoutingStateService } from 'src/app/core/services/routing-state.service';
import { AppDefaultDateType } from 'src/app/core/types/app-default-date-type.type';
import { AppDirection } from 'src/app/core/types/app-direction.type';
import { AppFieldSearcherStatus } from 'src/app/core/types/app-field-searcher-status.type';
import { FieldSearcherType } from 'src/app/core/types/app-field-searcher-type.type';
import { BaseComponentComponent } from '../../components/base/base-component/base-component.component';
import {
  ComparisonObject,
  LogicalComparisonOperator,
} from './../../../core/api/models';
import { ComparisonOperator } from './../../../core/api/models/comparison-operator';
import { GetEnumValuesDto } from './../../../core/api/models/get-enum-values-dto';
import { EnumsService } from './../../../core/api/services/enums.service';
import { ComparisonOperatorEnumDisplay } from './../../../core/enums/display/comparison-operator.display';
import { DateTimeService } from './../../../core/services/date-time.service';
import { SavedEnumsService } from './../../../core/services/saved-enums.service';
import { FieldSearcherOutput } from './field-searcher-event.model';

@Component({
  selector: 'app-field-searcher',
  templateUrl: './field-searcher.component.html',
  styleUrls: [
    './field-searcher.component.scss',
    '../../../../app/shared/components/form-kit/timepicker/timepicker.component.scss',
  ],
  standalone: false,
})
export class FieldSearcherComponent
  extends BaseComponentComponent
  implements OnInit
{
  //#region properties
  route = inject(ActivatedRoute);
  routingState = inject(RoutingStateService);

  readonly searchInput = viewChild<ElementRef>('searchInput');
  readonly searchInput2 = viewChild<ElementRef>('searchInput2');
  readonly filterMenuBtn = viewChild<MatMenuTrigger>('filterMenuBtn');
  readonly searchEnumInput = viewChild<ElementRef>('searchEnumInput');

  @Input() type: FieldSearcherType;
  @Input() fieldName: string;
  @Input() customOperators: number[] = [];
  @Input('inputDirection') dir: AppDirection = 'rtl';
  @Input() enumName: string;
  @Input() enumValues: GetEnumValuesDto[];
  @Input() dateDefaultValue: any;
  @Input() defaultSearchValue: any;
  @Input() defaultOperator: ComparisonOperator = ComparisonOperator.EqualTo;
  @Input() defaultDateType: AppDefaultDateType = 'both';
  @Input() noNumberSeparator: boolean;
  @Input() hasSelectAll: boolean = true;
  @Input() hasMatToolTip: boolean = true;
  @Input() isRequired: boolean = true;
  @Input() clearFilters: boolean = true;

  status: AppFieldSearcherStatus = 'empty';
  startDate: string;
  endDate: string;
  startTime: string;
  endTime: string;
  option_true: string = 'option_true_';
  option_false: string = 'option_false_';

  get ComparisonOperator() {
    return ComparisonOperator;
  }
  isShowComparisonItem2: boolean = false;
  baseEnumValues: GetEnumValuesDto[];

  //#region operators

  numberOperators = [
    ComparisonOperator.EqualTo,
    ComparisonOperator.NotEqualTo,
    ComparisonOperator.GreaterThan,
    ComparisonOperator.LessThan,
    ComparisonOperator.GreaterThanOrEqual,
    ComparisonOperator.LessThanOrEqual,
  ];
  textOperators = [
    ComparisonOperator.StartsWith,
    ComparisonOperator.EqualTo,
    ComparisonOperator.Contains,
    ComparisonOperator.EndsWith,
  ];
  enumOperators = [ComparisonOperator.EqualTo, ComparisonOperator.NotEqualTo];
  auditTextOperators = [
    ComparisonOperator.Contains,
    ComparisonOperator.StartsWith,
  ];
  auditNumberOperators = [
    ComparisonOperator.EqualTo,
    ComparisonOperator.GreaterThan,
    ComparisonOperator.LessThan,
    ComparisonOperator.GreaterThanOrEqual,
    ComparisonOperator.LessThanOrEqual,
  ];
  operatorIcons = [
    //None
    'mdi-menu-left', // none
    //Number
    'mdi-code-equal', //EqualTo
    'mdi-code-not-equal', //NotEqualTo
    'mdi-code-greater-than', //GreaterThan
    'mdi-code-less-than', //LessThan
    'mdi-code-greater-than-or-equal', //GreaterThanOrEqual
    'mdi-code-less-than-or-equal', //LessThanOrEqual
    //String
    'mdi-text-box-search-outline', //Contains
    'mdi-text-box-remove-outline', //NotContains
    'mdi-arrow-left', //StartsWith
    'mdi-arrow-right', //EndsWith
  ];
  //#endregion

  //operator enum display
  public ComparisonOperatorEnumDisplay: typeof ComparisonOperatorEnumDisplay =
    ComparisonOperatorEnumDisplay;

  //Use for filters that have one field. Example Number Type Or Text Type
  comparisonItem: ComparisonObject = {};
  comparisonItem2: ComparisonObject = {};

  //Use for filters that have more than two fields. Example Date Type
  comparisonItemList: ComparisonObject[] = [];
  selectedEnumValues: any[] = [];
  inputNumberValue: string;

  @Output('comparisonObject') output_comparisonObject =
    new EventEmitter<FieldSearcherOutput>();
  //#endregion

  constructor(
    protected renderer: Renderer2,
    protected enumService: EnumsService
  ) {
    super();
  }

  ngOnInit() {
    this.initData();
    this.option_true = this.option_true + this.fieldName?.split('_')[0];
    this.option_false = this.option_false + this.fieldName;
    this.setModelFromUrl();
    if (this.comparisonItem.value)
      this.comparisonItem.value = decodeURIComponent(this.comparisonItem.value);
  }

  setModelFromUrl() {
    // اگر پارامترهای جستجو خالیست آیتم‌ها را پاک کن
    if (window.location.search === '') {
      this.clearItems();
      return;
    }

    let filteredParams = [];
    const url = new URLSearchParams(window.location.search);
    const params = {};

    // فیلتر کردن پارامترهای جستجو که مورد نیاز نیستند
    url.forEach((value, key) => {
      if (
        key.toLowerCase() != QueryStringTypes.PageNumber &&
        key.toLowerCase() != QueryStringTypes.PageSize &&
        !key.startsWith(QueryStringTypes.Sort) &&
        !key.startsWith('key-')
      ) {
        params[key] = value;
      }
    });

    this.comparisonItemList = [];

    // گرفتن پارامترهای جستجو
    // logicalOperator => and , or
    Object.entries(params).forEach(([key, value]) => {
      let [fieldName, operator, logicalOperator, index] = key?.split('_');

      if (fieldName === this.fieldName && value !== undefined) {
        switch (this.type) {
          case 'enum':
            if (!this.selectedEnumValues.some((a) => +a == +value))
              this.selectedEnumValues.push(+value);
            break;
          case 'date':
            this.setDateValues(index, value);
            break;
          case 'dateTime':
            this.setDateTimeValues(index, value);
            break;
          case 'boolean':
            this.comparisonItem.value = value as string;
            break;
          case 'number':
            if (!filteredParams.includes(fieldName)) {
              this.inputNumberValue = value.toLocaleString();
              this.comparisonItem.value = value as string;
              this.comparisonItem.operator = +operator;
            } else {
              this.comparisonItem2.value = value as string;
              this.comparisonItem2.operator = +operator;
              this.isShowComparisonItem2 = true;
            }
            break;
          default: // "text" | "number" | "audit" | "auditNumber" | "auditText" | "enumValue" | "singleEnumSelect"
            if (!filteredParams.includes(fieldName)) {
              this.comparisonItem.value = value as string;
              this.comparisonItem.operator = +operator;
            } else {
              this.comparisonItem2.value = value as string;
              this.comparisonItem2.operator = +operator;
              this.isShowComparisonItem2 = true;
            }
        }
        this.comparisonItemList.push({
          field: fieldName,
          value: value as string,
          operator: +operator,
        });
        filteredParams.push(fieldName);

        this.status = 'set';
      }
    });
  }

  // تابع تنظیم تاریخ
  setDateValues(index, value) {
    const date = value?.split('T')[0];
    if (index === '0') {
      this.startDate = date;
    } else {
      this.endDate = date;
    }
  }

  // تابع تنظیم تاریخ و زمان
  setDateTimeValues(index, value) {
    let [date, time] = value?.split('T');
    const timeParts = time?.split(':');
    if (timeParts) {
      const hours = timeParts[0];
      const minutes = timeParts[1];
      time = `${hours}:${minutes}`;
    }

    if (index === '0') {
      this.startDate = date;
      this.startTime = time;
    } else {
      this.endDate = date;
      this.endTime = time;
    }
  }

  ngAfterViewInit() {
    this.inputListener();
    this.onSearch();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['dateDefaultValue']?.currentValue == null) {
      this.comparisonItemList.forEach((item) => {
        if (item.field == this.fieldName) item.value = '';
      });
      this.startDate = '';
      this.endDate = '';
      this.startTime = '';
      this.endTime = '';
      this.status = 'empty';
    } else if (changes['dateDefaultValue']?.currentValue) {
      this.dateDefaultValue = changes['dateDefaultValue']?.currentValue;

      this.setDefaultDate(true);
      this.status = 'set';
    }

    if (changes['clearFilters']) {
      this.setModelFromUrl();
    }
  }

  //#region text|number type

  inputListener() {
    if (['enum', 'enumValue', 'date', 'boolean'].includes(this.type)) return;
    const searchInput = this.searchInput();
    if (searchInput?.nativeElement)
      fromEvent(searchInput?.nativeElement, 'input')
        .pipe(
          takeUntil(this.onDestroy$),
          map((event) => event as KeyboardEvent),
          map((event) => (event.target as HTMLInputElement).value),
          map((value) => value.trim()),
          map((value) => (this.type == 'number' ? value?.toString() : value))
        )
        .subscribe((value) => {
          this.inputNumberValue = value;
          this.comparisonItem.value =
            this.type == 'number' ? value?.getJustNumbers().toString() : value;
        });
  }

  onChangeInput(event) {
    this.comparisonItem.value = event;
  }

  onChangeInputNumber2($event: Event) {
    const event = ($event.target as HTMLInputElement).value;
    this.comparisonItem2.value = event?.getJustNumbers().toString().trim();
  }

  onSearch() {
    if (!['enum', 'enumValue'].includes(this.type)) return;

    fromEvent(this.searchEnumInput().nativeElement, 'input')
      .pipe(
        takeUntil(this.onDestroy$),
        map((event) => event as KeyboardEvent),
        map((event) => (event.target as HTMLInputElement).value),
        map((value) => value.trim()),
        takeUntil(this.onDestroy$),
        map((searchText) => {
          if (!this.baseEnumValues) return [];

          //show all items
          if (!searchText)
            this.baseEnumValues.slice(0, this.baseEnumValues.length);

          // filter by search
          return this.baseEnumValues.filter(
            (item) => item.value?.toLowerCase().indexOf(searchText) > -1
          );
        })
      )
      .subscribe((value) => {
        this.enumValues = value;
      });
  }

  //#endregion

  //#region rule

  onAddRule() {
    switch (this.comparisonItem.operator) {
      case ComparisonOperator.LessThan:
      case ComparisonOperator.LessThanOrEqual:
        this.comparisonItem2.operator = ComparisonOperator.GreaterThan;
        break;
      case ComparisonOperator.GreaterThan:
      case ComparisonOperator.GreaterThanOrEqual:
        this.comparisonItem2.operator = ComparisonOperator.LessThan;
        break;
      default:
        this.comparisonItem2.operator = ComparisonOperator.LessThan;
        break;
    }
    this.isShowComparisonItem2 = true;
  }

  onRemoveRule(removeComparisonItem1: boolean) {
    const deletedComparisonItemOperator = this.comparisonItem.operator;

    if (removeComparisonItem1) {
      this.comparisonItem = Object.assign({}, this.comparisonItem2);
      this.comparisonItem.value = this.comparisonItem.value || '';
      this.comparisonItem2.operator = deletedComparisonItemOperator;
      this.renderer.setProperty(
        this.searchInput()?.nativeElement as HTMLInputElement,
        'value',
        this.comparisonItem.value
      );
    }

    this.comparisonItem2.value = '';

    this.renderer.setProperty(
      this.searchInput2()?.nativeElement as HTMLInputElement,
      'value',
      ''
    );

    this.isShowComparisonItem2 = false;

    if (this.status == 'set') this.onSubmit();
  }

  //#endregion

  //#region enum type

  addOrRemoveEnumValue(event: MatListOption) {
    const { value } = event;

    const index = this.selectedEnumValues.findIndex((val) => val == value);
    if (index > -1) this.selectedEnumValues.splice(index, 1);
    else this.selectedEnumValues.push(value);

    this.comparisonItemList = [];
    this.selectedEnumValues.forEach((value) => {
      this.comparisonItemList.push({
        field: this.fieldName,
        operator: +this.comparisonItem.operator,
        value,
      });
    });
  }

  // for enum dropDown type
  onSubmitSingleEnumSelector(event) {
    let enumValue = event.target.value;
    this.comparisonItem.value = enumValue;
    this.emitItem();
  }

  getEnumValuesApi(enumName) {
    const savedEnum = SavedEnumsService.getEnum(enumName);

    if (savedEnum != null) {
      this.enumValues = savedEnum;
      this.baseEnumValues = Object.assign([], savedEnum);
      if (
        this.defaultSearchValue != null &&
        this.defaultSearchValue != undefined
      ) {
        this.setDefaultEnumValue();
      }
    } else {
      this.enumService
        .enumsGetEnumValues({ EnumTypeName: enumName })
        .pipe(takeUntil(this.onDestroy$))
        .subscribe((values) => {
          this.enumValues = values.data;
          this.baseEnumValues = Object.assign([], this.enumValues);
          SavedEnumsService.pushEnum({
            enumName: enumName,
            enumValue: values.data,
          });
          if (
            this.defaultSearchValue != null &&
            this.defaultSearchValue != undefined
          ) {
            this.setDefaultEnumValue();
          }
        });
    }
  }

  setDefaultEnumValue() {
    if (!this.selectedEnumValues.some((a) => a == this.defaultSearchValue))
      this.selectedEnumValues.push(this.defaultSearchValue);

    if (
      this.enumName &&
      !this.comparisonItemList.some((a) =>
        a.field == this.fieldName && +a.operator == +this.defaultOperator
          ? this.defaultOperator
          : ComparisonOperator.EqualTo && a.value == this.defaultSearchValue
      )
    )
      this.comparisonItemList.push({
        field: this.fieldName,
        value: this.defaultSearchValue,
        operator: this.defaultOperator
          ? this.defaultOperator
          : ComparisonOperator.EqualTo,
      });

    this.emitItems();
    this.status = 'set';
  }

  //#endregion

  //#region date type

  onGetDate(value, operator) {
    let date: string;
    // convert date to utc
    if (value?._d) date = DateTimeService.toUTC(value._d?.toString().toUTC());
    else date = value;
    if (!date) date = DateTimeService.getCurrentDateTime();

    // agar tarikh ra kamtar az ... entekhab kard
    if (operator === ComparisonOperator.LessThan) {
      if (date && this.endTime) {
        this.endDate = date;
        date = date?.split('T')[0];
        date = date + `T${this.endTime}:59`;
      } else {
        date = date?.split('T')[0];
        date = date + 'T23:59:59';
      }
    }
    if (operator === ComparisonOperator.GreaterThan) {
      if (date && this.startTime) {
        this.startDate = date;
        date = date?.split('T')[0];
        date = date + `T${this.startTime}:00`;
      }
    }

    //remove old date
    this.removeFromItems(operator, this.fieldName);

    // set item
    this.comparisonItemList.push({
      field: this.fieldName,
      value: date,
      operator: operator,
    });
  }

  onRemoveDate(operator) {
    this.comparisonItemList.forEach((item) => {
      if (item.operator === operator && item.field == this.fieldName)
        item.value = '';
    });

    if (operator === ComparisonOperator.GreaterThan) this.startDate = '';
    else if (operator === ComparisonOperator.LessThan) this.endDate = '';

    // if (this.status == 'set')   this.emitItems();

    if (!this.endDate && !this.startDate) this.status = 'empty';
  }

  onRemoveTime(operator) {
    this.comparisonItemList.forEach((item) => {
      if (
        item.operator === operator &&
        item.field == this.fieldName &&
        item.value != ''
      ) {
        if (operator === ComparisonOperator.GreaterThan) {
          // item.value = '';
          item.value = item.value?.split('T')[0];
          item.value = item.value + 'T00:00:00';
        } else if (operator === ComparisonOperator.LessThan) {
          item.value = item.value?.split('T')[0];
          item.value = item.value + 'T23:59:59';
        }
      }
    });

    if (operator === ComparisonOperator.GreaterThan) this.startTime = '';
    else if (operator === ComparisonOperator.LessThan) this.endTime = '';

    if (!this.endTime && !this.startTime && !this.endDate && !this.startDate)
      this.status = 'empty';
  }

  clearDateFilter() {
    this.comparisonItemList.forEach((item) => {
      if (item.field == this.fieldName) item.value = '';
    });

    this.startDate = '';
    this.endDate = '';
    this.startTime = '';
    this.endTime = '';

    this.emitItems();

    this.status = 'empty';
  }

  //#endregion

  //#region boolean type

  onChangeBooleanTypeSelectOption(event) {
    let value = event.target.value;
    if (value.trim() === 'none') {
      this.clearItems();
      return;
    }
    this.comparisonItem.value = value;
    this.emitItem();
  }

  //#endregion

  //#region comparisonItems

  removeFromItems(operator, fieldName) {
    //get item index
    let itemIndex = this.comparisonItemList?.findIndex((item) => {
      return item.operator === operator && item.field == fieldName;
    });

    //delete
    if (itemIndex != -1) {
      this.comparisonItemList[itemIndex].value = '';
      this.comparisonItemList.splice(itemIndex, 1);
    }
  }

  emitItem() {
    this.changeStatus();
    this.comparisonItemList = [];
    this.comparisonItemList.push(this.comparisonItem);

    this.emitItems();
  }

  emitItems() {
    if (this.status == 'empty' && !this.comparisonItemList.length) return;

    //select And || Or for Logic
    let logicalComparisonOperator;
    switch (this.type) {
      case 'date':
      case 'dateTime':
      case 'number':
        logicalComparisonOperator = LogicalComparisonOperator.And;
        break;
      case 'enum':
        if (this.comparisonItem.operator == ComparisonOperator.NotEqualTo)
          logicalComparisonOperator = LogicalComparisonOperator.And;
        else logicalComparisonOperator = LogicalComparisonOperator.Or;
        this.comparisonItemList.forEach((value) => {
          value.operator = +this.comparisonItem.operator;
        });
        break;
      default:
        logicalComparisonOperator = null;
        break;
    }

    this.removeEmptyValueFromComparisonItemList();
    this.changeStatus();

    const comparisonObjectsWithLogic: FieldSearcherOutput = {
      comparisonObjects: this.comparisonItemList,
      fieldName: this.fieldName,
    };
    if (logicalComparisonOperator != null)
      comparisonObjectsWithLogic.logicalComparisonOperator =
        logicalComparisonOperator;
    this.output_comparisonObject.emit(
      Object.assign({}, comparisonObjectsWithLogic)
    );
  }

  clearItems() {
    if (
      !['enum', 'enumValue', 'date', 'dateTime', 'boolean'].includes(this.type)
    ) {
      this.renderer.setProperty(
        this.searchInput()?.nativeElement as HTMLInputElement,
        'value',
        ''
      );
      this.renderer.setProperty(
        this.searchInput2()?.nativeElement as HTMLInputElement,
        'value',
        ''
      );
    }
    this.selectedEnumValues = [];

    this.comparisonItem.value = '';
    this.comparisonItem2.value = '';

    this.setDefaultOperator();

    if (this.status == 'set') this.emitItem();
  }

  removeEmptyValueFromComparisonItemList() {
    this.comparisonItemList = this.comparisonItemList.filter(
      (item) => item.value || item.value == '0'
    );
  }

  //#endregion

  //#region common

  initData() {
    this.comparisonItem.field = this.fieldName;
    this.comparisonItem2.field = this.fieldName;

    //default type
    if (!this.type) this.type = 'text';
    if (this.type == 'number' || this.type == 'auditNumber') this.dir = 'ltr';

    this.setDefaultOperator();

    //for enum type
    if (
      (this.type == 'enum' ||
        this.type == 'enumValue' ||
        this.type == 'singleEnumSelect') &&
      !this.enumValues?.length
    )
      this.getEnumValuesApi(this.enumName);

    //set default date value
    if (this.dateDefaultValue) this.setDefaultDate();
  }

  setDefaultOperator() {
    // custom Operators
    if (this.customOperators?.length) {
      this.comparisonItem.operator = this.customOperators
        ? this.customOperators[0]
        : ComparisonOperator.StartsWith;
      return;
    }

    // other Operators
    switch (this.type) {
      case 'text':
      case 'auditText':
        this.comparisonItem.operator = ComparisonOperator.StartsWith;
        break;
      case 'number':
      case 'auditNumber':
        this.comparisonItem.operator = ComparisonOperator.EqualTo;
        break;
      case 'enumValue':
        this.comparisonItem.operator = ComparisonOperator.Contains;
        break;
      default:
        let operator = ComparisonOperator.EqualTo;
        let params = this.routingState.parseQueryString();
        for (const [key, value] of Object.entries(params)) {
          if (key.split('_')[0] == this.comparisonItem.field)
            operator = +key.split('_')[1];
        }
        this.comparisonItem.operator = operator;
        break;
    }

    if (
      this.defaultOperator &&
      this.defaultOperator != ComparisonOperator.EqualTo &&
      this.type == 'enum' &&
      window.location.search == ''
    )
      this.comparisonItem.operator = this.defaultOperator;
  }

  closeMenu() {
    this.filterMenuBtn().closeMenu();
  }

  changeStatus() {
    if (this.comparisonItemList?.length) this.status = 'set';
    else this.status = 'empty';
  }

  //isFromAdvancedSearch  برای اینه که تاریخ موقع جستجو با سرچ پیشرفته هم پاک نشه
  setDefaultDate(isFromAdvancedSearch?: boolean) {
    if (
      window.location.search.includes(this.fieldName) &&
      !isFromAdvancedSearch
    ) {
      this.emitItems();
      return;
    }
    switch (this.defaultDateType) {
      case 'both':
        this.startDate = this.dateDefaultValue;
        this.endDate = this.dateDefaultValue;
        break;
      case 'endDate':
        this.endDate = this.dateDefaultValue;
        break;
      case 'startDate':
        this.startDate = this.dateDefaultValue;
        break;
      default:
        this.startDate = this.dateDefaultValue;
        this.endDate = this.dateDefaultValue;
        break;
    }

    if (this.startDate && this.isRequired) {
      this.startDate = this.startDate?.split('T')[0];
      this.startDate = this.startDate + 'T00:00:00';
      if (!this.startTime) this.startTime = '00:00';
    }

    if (this.endDate) {
      this.endDate = this.endDate?.split('T')[0];
      this.endDate = this.endDate + 'T23:59:59';
      if (!this.endTime) this.endTime = '23:59';
    }

    if (this.startDate)
      this.comparisonItemList.push({
        field: this.fieldName,
        value: this.startDate,
        operator: ComparisonOperator.GreaterThan,
      });

    if (this.endDate)
      this.comparisonItemList.push({
        field: this.fieldName,
        value: this.endDate,
        operator: ComparisonOperator.LessThan,
      });

    this.emitItems();
  }

  submitWithEnter(event) {
    if (event.key !== 'Enter') return;

    this.onSubmit();
  }

  submitWithOperator(operator) {
    this.comparisonItem.operator = operator;

    this.onSubmit();
  }

  onSubmit() {
    this.closeMenu();

    if (
      !this.comparisonItem.value &&
      !this.comparisonItem2.value &&
      this.type == 'date'
    ) {
      this.clearDateFilter();
      return;
    }

    if (this.type != 'enum') {
      this.comparisonItemList = [];

      const items = [this.comparisonItem, this.comparisonItem2];

      items.forEach((item) => {
        if (item.operator) item.operator = Number(item.operator);
        this.comparisonItemList.push(item);
      });
    }

    this.emitItems();
  }

  //#endregion

  ngOnDestroy() {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
